import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { UpgradeOffer } from '../components/shop/UpgradeOffer';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function UpgradePage() {
  const [sp] = useSearchParams();
  const token = sp.get('token') || '';
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    axios.get(`${API}/upgrade-offer`, { params: { token } })
      .then((r) => setState({ quote: r.data.quote }))
      .catch((e) => setState({ error: e?.response?.data?.detail || 'This upgrade link is not valid.' }));
  }, [token]);

  const start = (body) => axios.post(`${API}/upgrade-offer/checkout`, { token, payment_method: body.payment_method, origin_url: body.origin_url });

  return (
    <div className="min-h-screen pt-28 pb-20 bg-[#FAF7F2]" data-testid="upgrade-page">
      <div className="container-custom max-w-2xl">
        <span className="eyebrow mb-4"><span className="w-10 h-px bg-[#C5A059]" /> Your personal offer</span>
        <h1 className="font-display text-4xl sm:text-5xl font-medium text-[#1E1622] mb-8">Complete your move plan</h1>
        {state.loading && <Loader2 className="animate-spin text-[#3B164C]" size={32} />}
        {state.quote && <UpgradeOffer quote={state.quote} start={start} />}
        {(state.error || (!state.loading && !state.quote)) && (
          <div className="rounded-2xl border border-[#E6DAC5] bg-white p-8" data-testid="upgrade-unavailable">
            <p className="text-[#1E1622]/70 mb-4">{state.error || "This offer is no longer available. You may already own the Bundle."}</p>
            <Link to="/orders" className="link-gold">Go to My Orders</Link>
          </div>
        )}
      </div>
    </div>
  );
}
